import React from "react";
import { useI18n } from "@/i18n/I18nContext";

const STATUS_STYLE = {
  NEW: { bg: "#EBF3FF", border: "#B8D5FF", text: "#1E5299" },
  ACTION_REQUIRED: { bg: "#FDF2F0", border: "#F8C7C0", text: "#C03A2B" },
  WAITING_FOR_USER: { bg: "#FFF8EC", border: "#FFE2B3", text: "#B36B00" },
  WAITING_FOR_INSTITUTION: { bg: "#F2F7F4", border: "#C4DFD2", text: "#2D5A4C" },
  RESOLVED: { bg: "#EDF7F2", border: "#B3E2CB", text: "#1B6943" },
  ARCHIVED: { bg: "#F1F3F2", border: "#D2D6D4", text: "#5A625E" },
};

export function StatusBadge({ status, className = "" }) {
  const { t } = useI18n();
  const s = STATUS_STYLE[status] || STATUS_STYLE.NEW;
  return (
    <span
      data-testid="case-status-badge"
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${className}`}
      style={{ backgroundColor: s.bg, border: `1px solid ${s.border}`, color: s.text }}
    >
      {t(`status.${status}`)}
    </span>
  );
}

export const CASE_STATUSES = Object.keys(STATUS_STYLE);
